<script setup lang="ts">

import { usePresentation } from '@/modules/Presentation/Types';
import { Map } from '../../Types/Map';

const presentation = usePresentation();

presentation.backgroundImage = '/images/sample/gkr-watermark.png';
presentation.onSetNext = () => ({ section: Map.YourDojo, page: 0 });

</script>

<template>
    <Page>

        <ImageAndText 
            animation="zoom"
            :src="`/HowCanWeHelp/women.jpg`"
            image-class="rounded-xl"
            floor-shadow
            flip>

            <div >
                <h1 class="text-3xl font-semibold mb-4">For Women, By People Who Understand</h1>
                <p class="text-lg">
                    We create a welcoming, ego-free space where women of all fitness levels 
                    thrive. Our classes are structured to improve physical strength while also 
                    developing mental resilience and calm under pressure.
                </p>
            </div>

        </ImageAndText>
    </Page>
</template>